import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SvgIcon from "../../../../assets/images/dog.png";
import "./addpet.css";
import { singlePet } from "redux-store/pets/pet.selector";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { singlePetClean, addNewPetByAdmin } from "redux-store/pets/pet.slice";
import { useParams, useNavigate } from "react-router-dom";
import { petError, petActivityInProcess, successMessage } from "redux-store/pets/pet.selector";
import { errorClean, messageClean } from "redux-store/pets/pet.slice";
import { validatePetBreed, validatePetName } from "components/utils/regexValidation";
import CreatableSelect from "react-select/creatable";
import { breedList } from "components/constants/petBreeds";

export default function AddPet() {
  const { userId } = useParams();

  const pet = useSelector(singlePet);
  const [breeds, setBreeds] = useState(breedList);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector(petActivityInProcess);
  const petSuccessMessage = useSelector(successMessage);
  const errorMessage = useSelector(petError);
  const [editPhoto, setEditPhoto] = useState<any>("");
  const [startDate, setStartDate] = useState<any>();
  const [petBreed, setBreed] = useState();
  const [formData, setFormData] = useState({
    ownerId: userId || "",
    petName: "",
    petType: "",
    petBreed: "",
    petGender: "",
    cancerSuspicion: false,
    petWeight: "",
    birthDate: "",
    photo: "",
    medicalChart: "",
  });

  const data = [
    {
      name: "petName",
      label: "Pet First Name",
      type: "text",
      placeholder: "Tomy",
    },
    { name: "petType", label: "Pet Type", type: "text", placeholder: "Dog" },
    {
      name: "petBreed",
      label: "Pet Breed",
      type: "text",
      placeholder: "Poodle",
    },
    {
      name: "petGender",
      label: "Pet Gender",
      type: "text",
      placeholder: "Male",
    },
    {
      name: "petWeight",
      label: "Pet Weight (lbs) - Best Guess",
      type: "number",
      placeholder: "25",
    },
    {
      label: "Pet's Date of Birth - Best Guess",
      type: "date",
      placeholder: "May",
      name: "birthDate",
    },
    {
      label: "Purpose of Screening",
      type: "radio",
      placeholder: "",
      name: "cancerSuspicion",
    },
    // {
    //   label: "Wellness Screen",
    //   type: "radio",
    //   placeholder: "",
    //   name: "wellnessScreen",
    // },
    {
      name: "medicalChart",
      label: "Health Concerns",
      type: "textarea",
      placeholder: "Pet's health concerns",
    },
    {
      name: "photo",
      label: "Photo",
      type: "file",
      placeholder: "Enter City",
    },
  ];

  const [errMessages, setMessages] = useState({
    imageMessage: "",
    chartMessage: "",
    nameMessage: "",
    breedMessage: "",
    genderMessage: "",
    emptyMessage: "",
  });

  const onBreedChange = (e: any) => {
    setBreed(e);
    setFormData({ ...formData, petBreed: e.value });
  };

  const onChange = (e: any) => {
    const node = e.target;
    let value;
    if (node.type === "radio" && node.id === "wellness") {
      value = false;
    } else if (node.type === "radio" && node.id === "cancer") {
      value = true;
    } else {
      value = node.value;
    }
    setFormData({ ...formData, [node.name]: value });
  };

  const dateChangeHandler = (date: any) => {
    setFormData({ ...formData, birthDate: date });
  };

  function handleImages(e: any, fileName: any) {
    e.preventDefault();
    const name = e.target.name;

    for (const file of e.target.files) {
      if (name === "photo") {
        if (!file?.name?.match(/\.(jpg|jpeg|png|webp|avif)$/)) {
          setMessages({
            ...errMessages,
            imageMessage: "Invalid File",
            chartMessage: "",
          });
          return;
        }
      } else if (name === "medicalChart") {
        if (!file?.name?.match(/\.(jpg|jpeg|png|webp|avif|pdf)$/)) {
          setMessages({
            ...errMessages,
            imageMessage: "",
            chartMessage: "Invalid File",
          });
          return;
        }
      }
      if (file.size > 2 * 1024 * 1024) {
        if (name === "photo") {
          setMessages({
            ...errMessages,
            imageMessage: "Invalid File Size",
            chartMessage: "",
          });
        } else {
          setMessages({
            ...errMessages,
            imageMessage: "",
            chartMessage: "Invalid File Size",
          });
        }
        return;
      }
      setMessages({
        ...errMessages,
        imageMessage: "",
        chartMessage: "",
      });
      setFormData({ ...formData, [e.target.name]: file });
      fileName === "photo" && setEditPhoto(file);
    }
  }

  function handleClick(e: any) {
    e.preventDefault();
    dispatch(errorClean());
    if (petSuccessMessage !== "") {
      dispatch(messageClean());
    }

    const isFormComplete = Object.entries(formData).every(
      ([key, value]) => key === "petID" || key === "ownerId" || (value !== "" && value !== undefined && value !== null)
    );

    setMessages({ ...errMessages, emptyMessage: "" });
    if (!validatePetName(formData?.petName)) {
      setMessages({
        ...errMessages,
        nameMessage: "Pet Name should be text",
        breedMessage: "",
      });
      // return;
    }
    if (!validatePetBreed(formData?.petBreed)) {
      setMessages({
        ...errMessages,
        nameMessage: "",
        breedMessage: "Breed Should be text",
      });
      // return;
    }
    setMessages({
      ...errMessages,
      emptyMessage: "",
      breedMessage: "",
      nameMessage: "",
      imageMessage: "",
      genderMessage: "",
      chartMessage: "",
    });
    let pet = new FormData();
    pet.append("ownerId", formData.ownerId as string);
    pet.append("petName", formData?.petName);
    pet.append("petType", formData.petType);
    pet.append("petBreed", formData.petBreed);
    pet.append("petGender", formData.petGender);
    pet.append("petWeight", formData.petWeight);
    pet.append("birthDate", formData.birthDate);
    pet.append("cancerSuspicion", formData.cancerSuspicion + "");
    pet.append("photo", formData.photo);
    pet.append("medicalChart", formData.medicalChart);

    dispatch(addNewPetByAdmin(pet)).then((res) => {
      if (res.payload.message === "Pet detailed added") {
        navigate("/admin/users");
      }
    });
  }

  useEffect(() => {
    try {
      if (params.path === "add") {
        dispatch(singlePetClean());
      }
    } catch (error) {
      console.log(error);
    }
  }, [pet]);

  useEffect(() => {
    dispatch(errorClean());
    dispatch(messageClean());
  }, [petSuccessMessage]);

  const breedInputStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: "55px",
      minWidth: "270px",
    }),
  };

  return (
    <div className=" tw-px-2 sm:tw-px-5 lg:tw-px-10 tw-flex tw-flex-col tw-gap-10">
      <div className="tw-px-4 sm:tw-px-7 lg:tw-px-10 tw-py-2 tw-flex tw-flex-col gap-3 tw-w-full tw-bg-[#FFFFFF] tw-rounded-2xl tw-shadow-3xl">
        <div className="tw-pt-4">
          <span className="tw-font-bold tw-text-[20px] md:tw-text-[26px] lg:tw-text-3xl">
            {params.path === "edit" ? "Edit Pet Details" : "Add New Pet"}
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-4 tw-text-[20px]">
          {data.map((key: any, i) =>
            key.label !== "Pet's Date of Birth - Best Guess" ? (
              key.label !== "Photo" && key.label !== "Medical Chart" ? (
                key.label === "Pet Type" ? (
                  <div className="tw-flex tw-flex-col tw-items-start tw-flex-1">
                    <label className="tw-font-semibold tw-text-[18px] sm:tw-text-[20px] lg:tw-text-2xl tw-flex tw-gap-1 tw-items-start">
                      {key.label} <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal">*required</p>
                    </label>
                    <select
                      name={key.name}
                      className=" tw-appearance-none tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 lg:tw-w-[50%] tw-placeholder-gray-400 tw-font-light"
                      onChange={onChange}
                      placeholder="PetType"
                      required
                    >
                      <option value="dog">{formData.petType ? formData.petType : "Pet Type"}</option>
                      <option value="dog">Dog</option>
                    </select>
                  </div>
                ) : key.label === "Pet Gender" ? (
                  <div className="tw-flex tw-flex-col tw-items-start tw-flex-1">
                    <label className="tw-font-semibold tw-text-[18px] sm:tw-text-[20px] lg:tw-text-2xl tw-flex tw-gap-1 tw-items-start">
                      {key.label} <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal">*required</p>
                    </label>
                    <select
                      name={key.name}
                      className=" tw-appearance-none tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 lg:tw-w-[50%] tw-placeholder-gray-400 tw-font-light"
                      onChange={onChange}
                      placeholder="Male"
                      required
                    >
                      <option value="">{formData.petGender ? formData.petGender : "Pet Gender"}</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Male Neutered">Male Neutered</option>
                      <option value="Female Spayed">Female Spayed</option>
                      <option value="Not Sure">Not Sure</option>
                    </select>
                  </div>
                ) : key.name !== "petBreed" ? (
                  <div className={`tw-flex tw-flex-col tw-flex-1 tw-items-start tw-gap-4`} key={i}>
                    <label
                      className={`tw-font-semibold tw-text-[18px] sm:tw-text-[20px] lg:tw-text-2xl tw-flex tw-gap-1 tw-items-start`}
                    >
                      {key.label}
                      <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal">*require</p>
                    </label>
                    {key.name === "medicalChart" && (
                      <div className="tw-text-gray-600 tw-text-[12px] tw-font-medium tw-px-2 tw-italic">
                        Please tell us any health concerns you have about your dog.
                      </div>
                    )}
                    {/* Default inputs */}
                    {key.type !== "radio" && (
                      <input
                        type={key.type}
                        name={key.name}
                        value={`${(formData as any)[key?.name] ? (formData as any)[key?.name] : ""}`}
                        className={`tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 ${
                          key.label === "Pet Weight -lbs Best - Guess"
                            ? "lg:tw-w-[40%] tw-placeholder-gray-400 tw-font-light"
                            : "lg:tw-w-1/2 tw-placeholder-gray-400 tw-font-light"
                        }`}
                        placeholder={key.placeholder}
                        onChange={onChange}
                        required
                      />
                    )}
                    {key.type === "radio" && (
                      <div className="tw-flex tw-gap-x-5 tw-ml-3">
                        <div className="tw-flex tw-gap-x-2">
                          <label className="tw-font-bold tw-text-base" htmlFor="cancer">
                            Cancer Suspicion
                          </label>
                          <input onChange={onChange} type="radio" name={key.name} id="cancer" />
                        </div>
                        <div className="tw-flex tw-gap-x-2">
                          <label className="tw-font-bold tw-text-base" htmlFor="wellness">
                            Wellness Screen
                          </label>
                          <input onChange={onChange} type="radio" name={key.name} id="wellness" />
                        </div>
                      </div>
                    )}
                    <span className=" tw-text-xs tw-text-red-500">
                      {key.name === "petName" ? errMessages.nameMessage : ""}
                    </span>
                  </div>
                ) : (
                  <div className="tw-flex tw-flex-col tw-flex-1 tw-items-start tw-gap-4" key={i}>
                    <label className="tw-font-semibold tw-text-[18px] sm:tw-text-[20px] lg:tw-text-2xl tw-flex tw-items-start tw-gap-1">
                      {key.label} <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal">*required</p>
                    </label>
                    <CreatableSelect
                      value={petBreed}
                      name="petBreed"
                      options={breeds}
                      isSearchable={true}
                      placeholder={key.placeholder}
                      onChange={onBreedChange}
                      styles={breedInputStyles}
                      required
                    />
                    <span className=" tw-text-xs tw-text-red-500">
                      {key.name === "petBreed" ? errMessages.breedMessage : ""}
                    </span>
                  </div>
                )
              ) : (
                <div className="tw-flex tw-flex-col tw-flex-1 tw-items-start tw-gap-4" key={i}>
                  {/* <label className="tw-font-semibold tw-flex tw-flex-col tw-gap-2">
                    <span className="tw-flex tw-gap-2 tw-items-start">
                      {key.label}
                      <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal">*optional</p>
                      <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal tw-flex tw-gap-2">
                        {key.name === "photo" && "Max size 2MB upload in Image PNG, JPG, JPEG"}
                        <span className=" tw-text-xs tw-text-red-500">
                          {key.name === "photo" ? errMessages.imageMessage : errMessages.chartMessage}
                        </span>
                      </p>
                    </span>
                    {key.name === "photo" && (
                      <p className=" tw-text-gray-600 tw-text-[12px] tw-font-medium tw-px-2 tw-italic">
                        Uploading a Picture and Medical chart may take a few minutes. Please wait till you get to the
                        next page
                      </p>
                    )}
                  </label> */}

                  {/* <div className="tw-flex tw-flex-col tw-w-full lg:tw-flex-row tw-gap-8 lg:tw-items-center ">
                    {key.label === "Photo" ? (
                      <img
                        src={
                          params.path === "edit"
                            ? editPhoto !== ""
                              ? URL.createObjectURL(editPhoto)
                              : formData.photo || SvgIcon
                            : editPhoto !== ""
                              ? URL.createObjectURL(editPhoto)
                              : SvgIcon
                        }
                        className=" tw-rounded-[50%] tw-h-[60px] tw-w-[60px] tw-object-cover"
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                    <label
                      className={`${key.type === "file" &&
                        "tw-flex tw-gap-2 file-input-label tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 lg:tw-w-1/2 tw-placeholder-gray-400 tw-font-light"
                        }`}
                    >
                      <input
                        type={key.type}
                        className="file-input tw-hidden"
                        name={key.name}
                        onChange={(e) => handleImages(e, key?.name)}
                      />
                      <span className="custom-icon"></span>
                      {`${(formData as any)[key?.name] ? "uploaded" : "Add or upload a file"}`}
                    </label>
                  </div> */}
                </div>
              )
            ) : (
              <div className="tw-flex tw-flex-col tw-flex-1 tw-items-start tw-gap-4" key={i}>
                <label className="tw-font-semibold tw-text-[18px] sm:tw-text-[20px] lg:tw-text-2xl tw-items-start tw-gap-1 tw-flex">
                  {key.label}
                  <p className=" tw-text-gray-400 tw-text-[12px] tw-font-normal">*required</p>
                </label>

                <DatePicker
                  name={key.name}
                  className="tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 tw-placeholder-gray-400 tw-font-light"
                  dateFormat="MM-dd-yyyy"
                  closeOnScroll={true}
                  placeholderText="MM/DD/YEAR"
                  maxDate={new Date()}
                  todayButton="Today Date"
                  selected={startDate}
                  onChange={(date: any) => {
                    setStartDate(date);
                    dateChangeHandler(date);
                  }}
                  customInput={
                    <input
                      type="text"
                      className="tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 tw-placeholder-gray-400 tw-font-light"
                      // Prevent focusing on the input field using the tabIndex property
                      tabIndex={-1}
                    />
                  }
                />
              </div>
            )
          )}
        </div>

        {petSuccessMessage !== "" && <span className=" tw-text-sm tw-text-green-500">{petSuccessMessage}</span>}

        {errMessages.emptyMessage !== "" && (
          <span className=" tw-text-xs tw-text-red-500">{errMessages.emptyMessage}</span>
        )}

        {errorMessage.message !== "" && <span className=" tw-text-xs tw-text-red-500">Error Occured</span>}
        <div className="tw-flex tw-gap-8 tw-text-[16px] lg:tw-text-[20px] tw-mb-8 tw-mt-2 lg:tw-mt-6 tw-place-items-center">
          <button
            disabled={loading}
            className=" tw-font-light tw-flex tw-items-center tw-p-5 sm:tw-p-5 tw-py-4 tw-px-5 tw-gap-2 tw-justify-center tw-h-[38px] sm:tw-h-[48px] tw-bg-[#FF7B6D] tw-rounded-xl tw-text-white"
            onClick={(e) => {
              handleClick(e);
            }}
          >
            {loading
              ? params.path === "edit"
                ? "Updating ..."
                : "Saving ..."
              : params.path === "edit"
              ? "Update"
              : "Save"}
          </button>
          <button
            className="tw-flex tw-border tw-items-center tw-border-black tw-p-3 sm:tw-p-3 tw-py-4 tw-px-5 tw-h-[42px] sm:tw-h-[48px] tw-rounded-xl"
            onClick={() => {
              navigate("/admin/users");
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
